import { Injectable } from "@angular/core";
import { I18nService } from "./i18n.service";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class LanguageHelperService {
  private currentLang = new BehaviorSubject<string>("fr");
  public currentLang$: Observable<string> = this.currentLang.asObservable();

  constructor(private i18nService: I18nService) {
    // Subscribe to language changes from the i18n service
    this.i18nService.getEmit.subscribe((lang) => {
      this.currentLang.next(lang || "fr");
    });
  }

  /**
   * Get confirmation dialog texts based on current language
   */
  getConfirmationTexts() {
    const lang = this.currentLang.getValue();

    if (lang === "fr") {
      return {
        title: "Êtes-vous sûr?",
        text: "Cette donnée sera supprimée définitivement!",
        confirmButtonText: "Supprimer",
        cancelButtonText: "Annuler",
      };
    } else {
      // Default to Turkish
      return {
        title: "Emin misin?",
        text: "Bu veri kalıcı olarak silinecek!",
        confirmButtonText: "Sil",
        cancelButtonText: "Vazgeç",
      };
    }
  }

  /**
   * Get common button texts based on current language
   */
  getButtonTexts() {
    const lang = this.currentLang.getValue();

    if (lang === "fr") {
      return {
        save: "Enregistrer",
        update: "Mettre à jour",
        cancel: "Annuler",
        delete: "Supprimer",
        add: "Ajouter",
        back: "Retour",
        close: "Fermer",
        yes: "Oui",
        no: "Non",
      };
    } else {
      // Default to Turkish
      return {
        save: "Kaydet",
        update: "Güncelle",
        cancel: "İptal",
        delete: "Sil",
        add: "Ekle",
        back: "Geri",
        close: "Kapat",
        yes: "Evet",
        no: "Hayır",
      };
    }
  }

  /**
   * Get notification texts based on current language
   */
  getNotificationTexts() {
    const lang = this.currentLang.getValue();

    if (lang === "fr") {
      return {
        success: "Succès",
        error: "Erreur",
        warning: "Avertissement",
        info: "Information",
        successMessage: "L'opération a été effectuée avec succès",
        errorMessage: "Une erreur s'est produite",
        warningMessage: "Transaction annulée",
      };
    } else {
      // Default to Turkish
      return {
        success: "Başarılı",
        error: "Hata",
        warning: "Uyarı",
        info: "Bilgi",
        successMessage: "İşlem başarıyla gerçekleştirildi",
        errorMessage: "Bir hata oluştu",
        warningMessage: "İşlem iptal edildi",
      };
    }
  }

  /**
   * Get the current language
   */
  getCurrentLang(): string {
    return this.currentLang.getValue();
  }
}
